import React, { Fragment } from 'react';
import { ExampleForm } from 'Components/Form/ExampleForm';

export const ExamplesForm: React.FC<any> = () => {
  return (
    <Fragment>
      <ExampleForm />
    </Fragment>
  ); 
}